import { HomeActionTypes } from './home-action';

export const initialState = {
  searchResult: {
    users: [],
    products: [],
    posts: [],
    is_empty: true,
  },
  searchValue: '',
  searchLoading: false,
  navigation: null,
  navigationLoading: false,
  holidayList: [],
  isMobileRoute: false,
};

function homeReducer(state = initialState, action: any) {
  switch (action.type) {
    case HomeActionTypes.SET_SEARCH_RESULTS:
      return {
        ...state,
        searchResult: action?.data,
        searchLoading: false,
      };

    case HomeActionTypes.GET_SEARCH_RESULTS:
      return {
        ...state,
        searchLoading: true,
      };

    case HomeActionTypes.SET_SEARCH_LOADING:
      return {
        ...state,
        searchLoading: action?.data?.searchLoading,
      };

    case HomeActionTypes.SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action?.data?.value,
      };

    case HomeActionTypes.SET_NAVIGATION:
      return {
        ...state,
        navigation: action?.data?.navigation ? { ...action.data.navigation } : null,
      };

    case HomeActionTypes.SET_NAVIGATION_LOADING:
      return {
        ...state,
        navigationLoading: action?.data?.loading,
      };

    case HomeActionTypes.SET_CALENDAR_HOLIDAY_LIST:
      return {
        ...state,
        holidayList: Object.keys(action?.data?.list),
      };

    case HomeActionTypes.SET_CURRENT_ROUTE_AFFIX:
      return {
        ...state,
        isMobileRoute: action?.data?.isMobileRoute,
      };

    default:
      return state;
  }
}

export default homeReducer;
